export const en = {
  app: {
    name: 'LogarGo',
    adminConsole: 'Admin Console',
  },
  nav: {
    dashboard: 'Dashboard',
    shipments: 'Shipments',
    statistics: 'Statistics',
    shipmentRequests: 'Shipment Requests',
    draftRequests: 'Draft Requests',
    jobs: 'Jobs',
    jobOffers: 'Job Offers',
    smsOptOuts: 'SMS Opt-outs',
    cargoReturns: 'Cargo Returns',
    mitigationLadder: 'Mitigation Ladder',
    accounts: 'Accounts',
    allAccounts: 'All Accounts',
    shippers: 'Shippers',
    freighters: 'Freighters',
    drivers: 'Drivers',
    vehicles: 'Vehicles',
    liveTracking: 'Live Tracking',
    verifications: 'Verifications',
    disputes: 'Disputes',
    scores: 'Scores',
    finance: 'Finance',
    penalties: 'Penalties & Compensations',
    subscriptions: 'Subscriptions',
    activeSubscriptions: 'Active Subscriptions',
    plans: 'Plans',
    entitlements: 'Add-ons',
    campaigns: 'Campaigns',
    billingControl: 'Billing control',
    notifications: 'Notifications',
    cronJobs: 'Cron Jobs',
    systemHealth: 'System Health',
    systemConfiguration: 'System Configuration',
    settings: 'Settings',
  },
  topbar: {
    switchToDark: 'Switch to dark mode',
    switchToLight: 'Switch to light mode',
    notifications: 'Notifications',
    profileSettings: 'Profile Settings',
    logout: 'Logout',
    administrator: 'Administrator',
    detach: 'Detach page',
    openNewTab: 'Open in new tab',
    openNewWindow: 'Open in new window',
  },
  settings: {
    title: 'Settings',
    subtitle: 'Manage your profile, language and appearance.',
    profileSection: 'Profile',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    role: 'Role',
    status: 'Status',
    accountId: 'Account ID',
    preferencesSection: 'Preferences',
    language: 'Language',
    languageHelp:
      'Updates your account locale on the server. You will be signed out and enum labels reload on next login.',
    languageChangeTitle: 'Change language',
    languageChangeConfirm: 'Switch interface and enum labels to {{language}}?',
    languageChangeConfirmHint:
      'Your account locale will be updated. You will be signed out, same as in the mobile apps.',
    languageChangeConfirmAction: 'Change & sign out',
    languageChangeFailed: 'Failed to update language',
    appearance: 'Appearance',
    themeMode: 'Theme',
    lightMode: 'Light',
    darkMode: 'Dark',
    languageChanged: 'Language updated',
    themeChanged: 'Theme updated',
    notProvided: 'Not provided',
  },
  login: {
    subtitle: 'Admin Console',
    emailLabel: 'Email Address',
    emailPlaceholder: 'admin@example.com',
    passwordLabel: 'Password',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    requiresAdmin: 'Requires SYSTEM_ADMIN privileges',
    accessDenied: 'Access denied. SYSTEM_ADMIN role required.',
    loginFailed: 'Login failed. Please try again.',
    copyright: '© {{year}} LogarGo. Shipper-Freighter Matching Platform.',
  },
  languages: {
    EN: 'English',
    HE: 'Hebrew',
    AR: 'Arabic',
    RU: 'Russian',
  },
}

export type TranslationResources = typeof en
